// import external dependencies
import 'jquery';
import 'bxslider/dist/jquery.bxslider.min.js';


// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_fontawesome.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import rewards from './routes/rewards';
import pageTemplateTemplateLocations from './routes/locations';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  aboutUs,
  rewards,
  pageTemplateTemplateLocations,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js